import { FormConfig, FormValues } from '@topdanmark-onlinesolutions/claim-form-types';
import { getArrayOfPagesShown } from '../helpers/getPageInfo';
import {
    trackYouAreCovered as itemsFromYouAreCovered,
    trackSupmanWidget as itemsFromSupmanWidget,
    trackReasons as itemsFromReasons
} from './common/auto.utils';
import { item as TrackingItem } from 'c9-tracking';
import { trackInfo } from './common/tracking';
import { getComponentFromComponentType } from '../helpers/getComponentFromComponentType';
import { getValue } from '../components/values/Get';
import { getPageIdOfElement } from '../helpers/getPageIdOfElement';
import { trackUpload } from './common/upload.utils';

/**
 * Auto tracking
 * Track you're covered (except trafikale-skader-andet-privat) and supman widget
 */

export const trackFormBySubmit = async (formConfig: FormConfig, formValues: FormValues) => {
    // Get array of page shown to only track pages which has been shown
    const shownPages = await getArrayOfPagesShown(formConfig, formValues);

    let trackingItems: TrackingItem[] = [];

    // Track user selection for upload (at least one file, no documentation, upload later)
    // EXPERIMENTAL
    if (formConfig.formId === 'parkeringsskade-privat') {
        trackingItems = trackingItems.concat(trackUpload(formConfig, formValues, 'fileUpload'));
    }

    if (getComponentFromComponentType(formConfig, 'youAreCovered')) {
        // Track you're covered / NOT used for trafikale-skader-andet-privat form
        if (
            formConfig.formId !== 'trafikale-skader-andet-privat' &&
            formConfig.formId !== 'haervaerk-koeretoej-privat'
        ) {
            trackingItems = trackingItems.concat(itemsFromYouAreCovered(formConfig, formValues));
        }

        // Track reasons
        trackingItems = trackingItems.concat(itemsFromReasons(formConfig, formValues));
    }

    // Track supman widget
    const supmanWidgetComponent = getComponentFromComponentType(formConfig, 'supManWidget');
    if (supmanWidgetComponent) {
        const pageIdOfSupmanWidget = getPageIdOfElement(formConfig, supmanWidgetComponent.elementId);
        if (pageIdOfSupmanWidget && shownPages.includes(pageIdOfSupmanWidget)) {
            const supmanWidgetValue = getValue(formConfig, formValues, supmanWidgetComponent.elementId);
            trackingItems = trackingItems.concat(itemsFromSupmanWidget(formConfig, supmanWidgetValue));
        }
    }

    if (trackingItems.length > 0) {
        trackInfo(formConfig, trackingItems);
    }
};
